import React from 'react';
import m from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { IntlProvider as Provider, createIntl, createIntlCache } from 'react-intl';

import moment from 'logic/moment';
import { langLowerCase } from 'selectors/user';
import i18nConfig from './config';
import { langs, resolveLangFromSearch } from './resolveLang';

export { langs };

let globalIntl = null; // Global intl reference
export const getIntl = () => globalIntl; // Access to global intl reference

class IntlProvider extends React.Component {
  constructor(props) {
    super(props);
    // addLocaleData(svLocaleData);

    let lang = resolveLangFromSearch(window.location.search, this.props.lang);

    if (process.env.NODE_ENV === 'test' && this.props.testLang) {
      lang = this.props.testLang;
    }

    this.state = { lang };
  }

  componentDidMount() {
    this.updateIntlInstance();
    this.checkInit();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.lang && this.state.lang !== nextProps.lang.toLowerCase()) {
      const lang = nextProps.lang.toLowerCase();
      const momentLang = lang === 'en' ? 'en-gb' : lang;

      m.locale(momentLang);
      moment.updateLocale(momentLang, m.localeData()._config);
      moment.locale(momentLang);

      // @todo hot change Google Charts locale
      this.setState({ lang }, this.updateIntlInstance);
    }
  }

  checkInit = () => {
    const { google } = window;

    if (google && google.charts) {
      google.charts.load('current', { packages: ['corechart'], language: this.state.lang });
    } else {
      setTimeout(this.checkInit, 300);
    }
  };

  updateIntlInstance = () => {
    const { lang } = this.state;
    const cache = createIntlCache();
    globalIntl = createIntl(
      {
        locale: lang,
        messages: i18nConfig[lang].messages,
      },
      cache,
    );
  };

  render() {
    const { lang } = this.state;

    return (
      <Provider
        locale={lang}
        messages={i18nConfig[lang].messages}
        defaultLocale={lang} // To show '[React Intl]' errors comment this line
        textComponent={React.Fragment}
      >
        <MuiPickersUtilsProvider
          utils={MomentUtils}
          libInstance={moment}
          locale={lang === 'en' ? 'en-gb' : lang}
        >
          {this.props.children}
        </MuiPickersUtilsProvider>
      </Provider>
    );
  }
}

IntlProvider.propTypes = {
  children: PropTypes.node,
  lang: PropTypes.oneOf(langs),
  testLang: PropTypes.oneOf(langs),
};

const mapStateToProps = (state) => ({
  lang: langLowerCase(state),
});

export default connect(mapStateToProps)(IntlProvider);
